<template>
  <page>
    <v-flex xs12>
      <form data-vv-scope="filters">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="filters.jobName"
                          :label="labels.jobName"
                          :error-messages="errors.collect('filters.jobName')"
                          data-vv-name="filters.jobName"
                          :data-vv-as="labels.jobName"
                          v-validate="'max:100'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-autocomplete
                          :items="rptStatuses"
                          v-model="filters.jobStatus"
                          :label="labels.jobStatus"
                          item-text="label"
                          item-value="value"
                          data-vv-name="filters.jobStatus"
                          :data-vv-as="labels.jobStatus"
                          :error-messages="errors.collect('filters.jobStatus')"
                          clearable
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="filters.jobRequestor"
                          :label="labels.jobRequestor"
                          :error-messages="errors.collect('filters.jobRequestor')"
                          data-vv-name="filters.jobRequestor"
                          :data-vv-as="labels.jobRequestor"
                          v-validate="'max:100'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <cal-picker
                          v-model="filters.dateCreatedFrom"
                          :label="labels.dateCreatedFrom"
                          :data-vv-as="labels.dateCreatedFrom"
                          data-vv-name="dateCreatedFrom"
                        ></cal-picker>
                      </v-flex>
                      <v-flex md6 xs12>
                        <cal-picker
                          v-model="filters.dateCreatedTo"
                          :label="labels.dateCreatedTo"
                          :data-vv-as="labels.dateCreatedTo"
                          data-vv-name="dateCreatedTo"
                        ></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-card>
      <v-flex xs12>
        <v-flex xs12 class="mt-1">
          <message :messages="messages"></message>
        </v-flex>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="showScheduleForm">
              Schedule Job
              <v-icon right>mdi-plus</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :loading="loading"
              :server-items-length="totalItems"
              :no-data-text="noDataText"
              v-bind:options.sync="pagination"
            >
              <template v-slot:item="row">
                <tr>
                  <td class="text-xs-left">{{ row.item.jobId }}</td>
                  <td class="text-xs-left">{{ row.item.jobNameDesc }}</td>
                  <td class="text-xs-left">{{ row.item.jobMode === 'ONCE' ? formatDisplayDateTime(row.item.jobSchedule) : row.item.jobCronDesc }}</td>
                  <td class="text-xs-left">{{ row.item.jobMode }}</td>
                  <td class="text-xs-left">{{ row.item.jobStatus }}</td>
                  <td class="text-xs-left">{{ formatDisplayDateTime(row.item.createdDate) }}</td>
                  <td class="text-xs-left">{{ row.item.jobRequestor }}</td>
                  <td class="text-right">
                    <v-tooltip bottom v-if="row.item.jobStatus === 'FAILED'">
                      <template v-slot:activator="{ on }">
                        <v-btn text icon color="red" v-on="on" @click="showErrorDialog(row.item)" class="tableActionBtn">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                        <span>Show error logs</span>
                      </template>
                    </v-tooltip>
                    <v-tooltip bottom v-if="row.item.jobStatus === 'PROCESSING'">
                      <template v-slot:activator="{ on }">
                        <v-btn text icon color="red" v-on="on" @click="doProcessJob(row.item, 'retry')" class="tableActionBtn">
                          <v-icon>mdi-minus-circle</v-icon>
                        </v-btn>
                        <span>Kill job</span>
                      </template>
                    </v-tooltip>
                    <v-tooltip bottom v-if="row.item.jobStatus !== 'COMPLETED' && row.item.jobStatus !== 'UNSCHEDULED'">
                      <template v-slot:activator="{ on }">
                        <v-btn text icon color="red" v-on="on" @click="doProcessJob(row.item, 'unschedule')" class="tableActionBtn">
                          <v-icon>mdi-calendar-remove</v-icon>
                        </v-btn>
                      </template>
                      <span>Unschedule job</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-card>
    <v-dialog v-model="errorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="selectedJob" class="pb-3">
            <span class="info-dialog-msg-header">Error Logs:</span>
            <v-spacer class="mt-2"></v-spacer>
            <ul class="showErrorMsgs">
              <li>
                {{ selectedJob.jobConsole }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="errorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showScheduleJob" width="800px" persistent>
      <form data-vv-scope="batchJobForm">
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-clock</v-icon>
            <v-toolbar-title>Schedule Job</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex md6 xs12>
                  <v-autocomplete
                    :items="jobNames"
                    v-model="batchFormField.jobName"
                    :label="batchFormLabel.jobName"
                    item-text="label"
                    item-value="value"
                    data-vv-name="batchFormField.jobName"
                    :data-vv-as="batchFormLabel.jobName"
                    :error-messages="errors.collect('batchFormField.jobName')"
                    v-validate="'required'"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex md6 xs12>
                  <v-autocomplete
                    :items="jobModes"
                    v-model="batchFormField.jobMode"
                    :label="batchFormLabel.jobMode"
                    item-text="label"
                    item-value="value"
                    data-vv-name="batchFormField.jobMode"
                    :data-vv-as="batchFormLabel.jobMode"
                    :error-messages="errors.collect('batchFormField.jobMode')"
                    v-validate="'required'"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex md12 xs12 v-if="batchFormField.jobMode === 'RECURRING'">
                  <v-combobox v-model="selectedDays" :items="days" label="Selected days" multiple chips></v-combobox>
                </v-flex>
                <v-flex md6 xs12 v-if="batchFormField.jobMode === 'ONCE'">
                  <cal-picker
                    v-model="batchFormField.jobSchedule"
                    :label="batchFormLabel.jobSchedule"
                    :error-messages="errors.collect('batchFormField.jobSchedule')"
                    :data-vv-as="batchFormLabel.jobSchedule"
                    v-validate="'required'"
                    data-vv-name="batchFormField.jobSchedule"
                  ></cal-picker>
                </v-flex>
                <v-flex md12 xs12>
                  <v-dialog ref="dialog" v-model="timeModal" :return-value.sync="batchFormField.jobScheduleTime" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="batchFormField.jobScheduleTime"
                        v-validate="'required'"
                        :data-vv-as="batchFormLabel.jobScheduleTime"
                        data-vv-name="batchFormField.jobScheduleTime"
                        :error-messages="errors.collect('batchFormField.jobScheduleTime')"
                        :label="batchFormLabel.jobScheduleTime"
                        readonly
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-time-picker v-if="timeModal" v-model="batchFormField.jobScheduleTime" full-width>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click="timeModal = false">Cancel</v-btn>
                      <v-btn color="primary" text @click="$refs.dialog.save(batchFormField.jobScheduleTime)">OK</v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showScheduleJob = false">Cancel</v-btn>
            <v-btn color="primary" @click="submitSchedule('schedule')">Schedule</v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>
    <warning v-model="showWarningMsg" @ok="processRequest"> {{ jobWarningMessage }}</warning>
  </page>
</template>
<script>
import { extractMenu } from '@/utils/extract'
import { formatDisplayDate2, formatDisplayDateTime, formatDisplayDateTime2, removeTime } from '@/utils/date'
import http, { expandURI, filterQuery } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import clone from 'clone'

export default {
  data() {
    return {
      toogleArray: [false],
      init: 0,
      timeModal: false,
      jobs: [],
      menu: {},
      selectedJob: undefined,
      errorDialog: false,
      showScheduleJob: false,
      processingFlag: false,
      totalItems: 0,
      showWarningMsg: false,
      headers: [
        { text: 'Job Id', value: 'jobId' },
        { text: 'Job Name', value: 'jobNameDesc' },
        { text: 'Schedule / Cron', value: 'jobSchedule' },
        { text: 'Frequency ', value: 'jobMode' },
        { text: 'Status ', value: 'jobStatus' },
        { text: 'Requested Date', value: 'createdDate' },
        { text: 'Requested By', value: 'jobRequestor' },
        TableConst.tableActionHeader
      ],
      labels: {
        jobName: 'Job Name',
        jobStatus: 'Job Status',
        jobRequestor: 'Requested By',
        dateCreatedFrom: 'Requested Date From',
        dateCreatedTo: 'Requested Date To'
      },
      filters: {
        jobName: null,
        jobStatus: null,
        jobRequestor: null,
        dateCreatedFrom: null,
        dateCreatedTo: null
      },
      rptStatuses: [
        { label: 'Scheduled', value: 'Scheduled' },
        { label: 'Completed', value: 'Completed' },
        { label: 'Processing', value: 'Processing' },
        { label: 'Failed', value: 'Failed' },
        { label: 'Unscheduled', value: 'Unscheduled' }
      ],
      batchFormField: {
        jobId: null,
        jobName: '',
        jobSchedule: null,
        jobMode: '',
        jobScheduleTime: '',
        actionName: '',
        jobTimeKey: null,
        jobCron: null
      },
      batchFormLabel: {
        jobName: 'Job Name',
        jobCron: 'Job Cron Expression',
        jobSchedule: 'Schedule Date',
        jobMode: 'Frequency',
        jobScheduleTime: 'Schedule Time'
      },
      jobNames: [
        { label: 'Claim Pending Registration Notification', value: 'qrtzClaimPendingRegistrationNotif' },
        { label: 'Claim Process RI Recoveries', value: 'qrtzClaimRiRcvry' },
        { label: 'Generate XOL', value: 'qrtzXOLRecoveryGenerate' },
        { label: 'Match Transactions', value: 'qrtzMatchTrans' }
      ],
      jobModes: [
        { label: 'Run Once', value: 'ONCE' },
        { label: 'Recurring', value: 'RECURRING' }
      ],
      jobWarningMessage: '',
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      selectedDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    async batchJobInit() {
      this.resetMessages()
      const apiUrl = this.$store.state.app.menu.batchJob
      if (apiUrl) {
        try {
          const result = await http.get(expandURI(apiUrl))
          this.menu = extractMenu(result.data._links)
          this.fetchBatchJobs()
        } catch (error) {
          this.$toast.error('There was an unexpected error during initialization.')
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async fetchBatchJobs(options) {
      this.init = 0
      const apiURI = this.menu.batchJobHistory
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let massageFilters = this.modifyFilters(clone(this.filters))
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result) {
            const { data } = result
            this.items = []
            if (data) {
              this.totalItems = result.data.totalElements
              this.$set(this, 'items', data.data)
            }
          }
          this.init = 1
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.init = 2
          this.loading = false
        }
      }
    },
    modifyFilters(massageFilters) {
      if (massageFilters.dateCreatedFrom !== null && massageFilters.dateCreatedFrom !== '') {
        massageFilters.dateCreatedFrom = formatDisplayDateTime2(removeTime(massageFilters.dateCreatedFrom))
      }
      if (massageFilters.dateCreatedTo !== null && massageFilters.dateCreatedTo !== '') {
        massageFilters.dateCreatedTo = formatDisplayDateTime2(removeTime(massageFilters.dateCreatedTo))
      }
      return massageFilters
    },
    submitSchedule(actionName) {
      this.resetMessages()
      this.$validator.validateAll('batchJobForm').then(result => {
        if (result) {
          this.generateCronExpression()
          this.batchFormField.actionName = actionName
          this.processRequest()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processRequest() {
      this.resetMessages()
      const apiURI = this.menu.performAction
      if (apiURI) {
        try {
          this.doBeforeProcessRequest()
          const result = await this.$http.post(apiURI, this.batchFormField)
          const { data } = result
          if (data) {
            this.doAfterProcessRequest()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.processingFlag = false
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doBeforeProcessRequest() {
      if (this.batchFormField.actionName === 'unschedule') {
        this.batchFormField.jobId = this.selectedJob.jobId
        this.batchFormField.jobName = this.selectedJob.jobName
        this.batchFormField.jobTimeKey = this.selectedJob.jobTimeKey
      }
    },
    doAfterProcessRequest() {
      if (this.batchFormField.actionName === 'unschedule') this.$toast.success('Job successfully unscheduled.')
      if (this.batchFormField.actionName === 'schedule') this.$toast.success('Job successfully scheduled.')
      this.fetchBatchJobs()
      this.showScheduleJob = false
    },
    showErrorDialog(job) {
      this.selectedJob = job
      this.errorDialog = true
    },
    doProcessJob(job, actionName) {
      this.selectedJob = job
      this.batchFormField.actionName = actionName
      this.jobWarningMessage = 'Are you sure you want to ' + actionName + ' job ' + job.jobNameDesc + '?'
      this.showWarningMsg = true
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('filters').then(result => {
        if (result) {
          this.fetchBatchJobs(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    showScheduleForm() {
      this.showScheduleJob = true
      this.batchFormField.jobId = ''
      this.batchFormField.jobName = ''
      this.batchFormField.jobSchedule = ''
      this.batchFormField.jobScheduleTime = '00:00'
      this.batchFormField.jobMode = ''
    },
    formatDisplayDate(myDate) {
      return formatDisplayDate2(myDate)
    },
    formatDisplayDateTime(myDate) {
      return formatDisplayDateTime(myDate)
    },
    doClearFilters() {
      this.filters.jobStatus = null
      this.filters.jobRequestor = null
      this.filters.jobName = null
      this.filters.dateCreatedFrom = null
      this.filters.dateCreatedTo = null
      this.fetchBatchJobs(false)
    },
    generateCronExpression() {
      // this.batchFormField.jobCron = '0/50 * * ? * *'
      // E.g 0 0 12 ? * *  => At 12:00:00pm every day
      // E.g 0 0 12 ? * Mon, Sun At 12:00:00pm, on every Monday and Sunday, every month
      // E.g 0 0 12 ? 2 Mon 2020 At 12:00:00pm, on every Monday, in February, in 2020
      let timeSplit = this.batchFormField.jobScheduleTime.split(':')
      if (this.selectedDays.length === 7) {
        // console.log('0 ' + Number(timeSplit[1]) + ' ' + Number(timeSplit[0]) + ' ? * *')
        this.batchFormField.jobCron = '0 ' + Number(timeSplit[1]) + ' ' + Number(timeSplit[0]) + ' ? * *'
      } else {
        // this.batchFormField.jobCron = '0 ' + Number(timeSplit[1]) + ' ' + Number(timeSplit[0]) + ' ? * *'
        // AR: Need to increase length of jobCron field console.log('0 ' + Number(timeSplit[1]) + ' ' + Number(timeSplit[0]) + ' ? * *')
        this.batchFormField.jobCron = '0 ' + Number(timeSplit[1]) + ' ' + Number(timeSplit[0]) + ' ? * ' + this.selectedDays.toString()
        // console.log(this.batchFormField.jobCron)
      }
    }
  },
  watch: {
    'pagination': function(value) {
      this.fetchBatchJobs(false)
    }
  },
  mounted() {
    this.batchJobInit()
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
